export class Exportland {
    exportland_id: number;
    kuerzel: string;
    land: string;
}
